import React from "react";
import {
    Card,
    Col,
    ConfigProvider,
    type TabsProps,
    Tabs,
} from "antd";
import {PageContainer} from "@ant-design/pro-layout";
import {IAppComponentProps} from "../../../components";
import styles from "../../../styles/scss/portal.scss";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import {CustomRender} from "../../../components/CustomRender";
import enUS from "antd/lib/locale/en_US";
import deDe from "antd/lib/locale/de_DE";
import {useIntl} from "react-intl";
import {getI18n} from '../../../utils/Utils';
import BorderoStatus from "./favor/bordero-status/BorderoStatusComponent";
import BeleganforderungComponent from "./favor/beleganforderung/BeleganforderungComponent";
import MyDocumentsFreightTab from "./index";
import { entitlementExists } from "../../../main/entitlementService";
import { ADDITIONAL_FREIGHT_TABS_ENTITLEMENT } from "./favor/freightEntitlements";

export const renderAsDate = (record) => <CustomRender record={record} renderAs="date"/>;
export const renderAsButton = (record) => <CustomRender record={record} renderAs="button"/>;

const MyDocuments: React.FunctionComponent<IAppComponentProps> = (props) => {
    const intl = useIntl();
    const canViewAdditionalTabs = entitlementExists(
        ADDITIONAL_FREIGHT_TABS_ENTITLEMENT,
        props.distinctEntitlements,
    );

    const sizes: React.CSSProperties = {
        height: "100%",
        width: "98%"
    };

    const tabItems: TabsProps["items"] = [
        {
            key: "1",
            label: getI18n(
                "Document-title-overview-documents",
                "Documents",
                intl,
            ),
            children: (
                <MyDocumentsFreightTab
                    intl={intl}
                    currentUser={props.currentUser}
                    distinctEntitlements={props.distinctEntitlements}
                />
            ),
        },
        ...(canViewAdditionalTabs
            ? [
                {
                    key: "2",
                    label: getI18n(
                        "freight-tab-status-bordero",
                        "Status Bordero",
                        intl,
                    ),
                    children: (
                        <BorderoStatus
                            currentUser={props.currentUser}
                            distinctEntitlements={props.distinctEntitlements}
                        />
                    ),
                },
                {
                    key: "3",
                    label: getI18n(
                        "freight-tab-document-requests",
                        "Document Requests",
                        intl,
                    ),
                    children: (
                        <BeleganforderungComponent
                            currentUser={props.currentUser}
                            distinctEntitlements={props.distinctEntitlements}
                        />
                    ),
                },
            ]
            : []),
    ];


    return (
        <ConfigProvider locale={localStorage.getItem("locale") === "us" ? enUS : deDe}>
            <PageContainer
                title={false}
                content={""}
                extraContent={""}
                className={styles.users}
                style={{background: "white"}}
            >
                <div style={{...sizes, minHeight: "200px"}} className="pl15 ag-theme-balham">
                    <Col md={24} sm={12} xs={24}>
                            <Card title={getI18n("freight_panel_header_title", "Document view", intl)}
                                     key="1">
                                <Tabs defaultActiveKey={'1'} className="users-tabs" items={tabItems} />

                            </Card>
                    </Col>
                </div>
            </PageContainer>
        </ConfigProvider>
    )
        ;
};
export default MyDocuments;
